import { render, staticRenderFns } from "./ChangguanNewsBlock.vue?vue&type=template&id=0dfe8126&scoped=true"
import script from "./ChangguanNewsBlock.vue?vue&type=script&lang=js"
export * from "./ChangguanNewsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe8126",
  null
  
)

export default component.exports